import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { GetDocumentListEmdEffect } from './get-document-list-emd.effect';
import { getDocumentListEmdReducer } from './get-document-list-emd.reducer';
import { GET_DOCUMENT_LIST_EMD_STORE_NAME, GetDocumentListEmdState } from './get-document-list-emd.state';

/** Token of the GetDocumentListEmd reducer */
export const GET_DOCUMENT_LIST_EMD_REDUCER_TOKEN = new InjectionToken<ActionReducer<GetDocumentListEmdState, Action>>(
  'Feature GetDocumentListEmd Reducer'
);

/** Provide default reducer for GetDocumentListEmd store */
export function getDefaultGetDocumentListEmdReducer() {
  return getDocumentListEmdReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(GET_DOCUMENT_LIST_EMD_STORE_NAME, GET_DOCUMENT_LIST_EMD_REDUCER_TOKEN),
    EffectsModule.forFeature([GetDocumentListEmdEffect]),
  ],
  providers: [{ provide: GET_DOCUMENT_LIST_EMD_REDUCER_TOKEN, useFactory: getDefaultGetDocumentListEmdReducer }],
})
export class GetDocumentListEmdStoreModule {
  public static forRoot<T extends GetDocumentListEmdState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<GetDocumentListEmdStoreModule> {
    return {
      ngModule: GetDocumentListEmdStoreModule,
      providers: [{ provide: GET_DOCUMENT_LIST_EMD_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
